// extracted by mini-css-extract-plugin
export default {"page":"Zga-z","cartModal":"_ga-z","checkout":"aha-z","placeholder":"bha-z","account":"cha-z"};